export default __webpack_public_path__ + "static/media/16.17bfc9fb.jpg";